import get from 'lodash.get';

const getUpgradeUrl = (rootState) => get(rootState, 'user.partnerData.properties.upgradeUrl', null);

export default getUpgradeUrl;
